import axios from 'axios';
import { SET_USER } from '../constants';

const setUser = user => ({
    type: SET_USER,
    user,
}) 

export const fetchUser = (app = 'register') => dispatch => 
    axios.get('/api/v3/auth/profile/')
        .then(res => res.data)
        .then(user => dispatch(setUser(user)))
        .catch(() => setUser({
            borrower: {},
            is_staff: false,
        }))


export const login = (data, app) => dispatch => 
    axios.post('/api/v3/auth/login/', data)
        .then(() => dispatch(fetchUser(app)));
